import { useQuery } from '@tanstack/react-query'
import { AdminConsoleOrgsApi } from '@portal/pkg-api/admin-console'
import { data } from '@portal/pkg-api/helpers'

const prefix = 'admin-console.organization'

export const OrganizationQueries = {
  list: () => ({
    queryKey: [prefix, 'list'],
    queryFn: () => data(AdminConsoleOrgsApi.listOrganizations()),
  }),
  details: (orgId: number) => ({
    queryKey: [prefix, 'details', orgId],
    queryFn: () => data(AdminConsoleOrgsApi.getOrganization(orgId)),
  }),
}

export function useOrgDetails(orgId?: number) {
  return useQuery({
    ...OrganizationQueries.details(orgId ?? 0),
    enabled: orgId !== undefined,
  })
}
